<template>
  <div class="stack">
    <div class="text-right" v-if="permissionCheck('news-categories-destroy')">
      <wd-button transparent @input="sendDelete" :sending="deleteSending">
        <icon name="Trash" size="1.5em" />
      </wd-button>
    </div>
    <form @submit.prevent="sendSubmit">
      <input-text required :value="formData.title" label="Titel" @update-value="updateForm('title', $event, id || 'NewNewsCategory')" />
      <input-text required :value="formData.icon" label="Icon" @update-value="updateForm('icon', $event, id || 'NewNewsCategory')" />
      <input-text required
        type="color"
        :value="formData.color"
        label="Farbe"
        @update-value="updateForm('color', $event, id || 'NewNewsCategory')"
      />
      <div @click="toggleImageSelect">
        <label v-if="formData.image_id">{{ $t('news.news_image') }}</label>
        <div class="cursor-pointer border border-primary-500 p-2" v-if="formData.image_id">
          <single-image :image-id="formData.image_id" />
        </div>
        <div class="border border-primary-500 p-2" v-else>
          <icon class="cursor-pointer" name="Image" size="1.5em" />
          <span class="ml-2">{{ $t('news.news_image') }}</span>
        </div>
      </div>
      <div class="flex justify-between">
        <div>
          <wd-button
            :disabled="!formData.title || !formData.color || !formData.icon"
            propagate
            :sending="sending"
          >{{ id ? $t("general.update") : $t("general.create") }}</wd-button>
        </div>
      </div>
    </form>
    <images v-if="imageSelect" @close="toggleImageSelect" @selection="updateImage" />
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";

import _ from "lodash";

const Images = require("@/modules/images/components/Images.vue").default;
const SingleImage = require("@/modules/images/components/SingleImage.vue")
  .default;

export default {
  name: "NewsCategoryManageSite",
  mixins: [FormMixin],
  data() {
    return {
      newsCategory: null,
      deleteSending: false,
      imageSelect: false
    };
  },
  props: {
    id: {
      type: String
    }
  },
  components: {
    SingleImage,
    Images
  },
  methods: {
    sendDelete() {
      this.$store.dispatch("dialog/add", {
        title: "Löschen bestätigen",
        text: `Kategorie wirklich löschen? Alle zugehörigen Items werden gelöscht!`,
        submitFn: () => {
          this.submit(this.deleteFormOptions);
        }
      });
    },
    sendSubmit(){
      if (this.formData.image_id) {
        this.submit(this.formOptions);
      }
    },
    toggleImageSelect() {
      this.imageSelect = !this.imageSelect;
    },
    updateImage(Image) {
      this.toggleImageSelect();
      this.updateForm("image_id", Image, this.id || 'NewNewsCategory');
    }
  },
  computed: {},
  async created() {
    if (this.id) {
      this.newsCategory = await this.$store.getters["newscategory/api"].Show(
        this.id
      );
      this.formData = Object.assign({}, this.newsCategory);

      this.formOptions = {
        async: true,
        type: "newscategory",
        call: "update",
        id: this.id,
        action: response => {
          this.$store.dispatch("temp/removeUnsavedItem", {item: this.id});
          this.popup({
            title: this.$t("news.manage.news_category_updated"),
            autohide: true
          });
        }
      };
    } else {
      this.formOptions = {
        async: true,
        type: "newscategory",
        call: "create",
        id: this.id,
        action: response => {
          this.$store.dispatch("temp/resetUnsaved");
          this.goTo("/news-categories");
          this.popup({
            title: this.$t("news.manage.news_category_created"),
            autohide: true
          });
        }
      };
    }

    this.deleteFormOptions = {
      async: true,
      type: "newscategory",
      call: "destroy",
      sendingVar: false,
      id: this.id,
      action: response => {
        this.$store.dispatch("temp/resetUnsaved");
        this.deleteSending = false;
        this.goTo("/news-categories");
        this.popup({
          title: this.$t("news.manage.news_category_deleted")
        });
      }
    };
    if (window.innerWidth > 1000) this.previewVisible = true;

    this.loaded();
  },
};
</script>